module.exports = __webpack_public_path__ + "img/login-background.08987bcf.svg";